/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/consultRoots';

let lbilMemberBaseUrl = root.lbilMemberFilterApiUrl.link;

export default {
  state: {
    getLbilMemberMainFiltersState:{},
    getLbilMemberMainFiltersByIdState:{}
  },
  mutations: {
    getLbilMemberMainFiltersMutation(state, value) {
      Vue.set(state, 'getLbilMemberMainFiltersState', value);
    },
    getLbilMemberMainFiltersByIdMutation(state, value) {
      Vue.set(state, 'getLbilMemberMainFiltersByIdState', value);
    },
  },
  actions: {
    // Get LbilMember Main Filters
    getLbilMemberMainFilterAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(lbilMemberBaseUrl, payload).then(res => {
              context.commit('getLbilMemberMainFiltersMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create LbilMember Main Filters
    createLbilMemberMainFilterAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(lbilMemberBaseUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get LbilMember Main Filter Details By Id
    getLbilMemberMainFilterDetailsByIdAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(lbilMemberBaseUrl + payload.id + '/').then(res => {
              context.commit('getLbilMemberMainFiltersByIdMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Lbil Member Main Filters
    updateLbilMemberMainFilterAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(lbilMemberBaseUrl + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Delete LbilMember Main Filters
    deleteLbilMemberMainFilterAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(lbilMemberBaseUrl + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
  },
  getters: {
    getLbilMemberMainFiltersGetters: state => state.getLbilMemberMainFiltersState,
    getLbilMemberMainFiltersByIdGetters: state => state.getLbilMemberMainFiltersByIdState,
  }
}